import React from "react";
import Link from "next/link";
import { cn } from "@/lib/utils";
import Image from "next/image";

const OurProgram = () => {
  const OUR_PROGRAMS = [
    {
      title: "B.Sc. (Hons) Software Engineering",
      image: "/course/se.jpg",
      bg: "",
      href: "/courses/bsc-software-engineering",
    },
    {
      title: "B.Sc. (Hons) BM with Business Analytics",
      image: "/course/bmwba.png",
      href: "/courses/bsc-business-management-business-analytics",

      bg: "",
    },
    {
      title: "B.Sc. (Hons) BM with Digital Marketing",
      image: "/course/bmwdm.png",
      href: "/courses/bsc-business-management-digital-marketing",

      bg: "",
    },
    {
      title: "B.Sc. (Hons) Business Management",
      image: "/course/bm.png",
      bg: "",
      href: "/courses/bsc-business-management",
    },
  ];

  return (
    <div
      className={cn(
        `2xl:p-[0_5rem] xl:p-[0_5rem] md:p-[0_3.125rem] `,
        `w-full max-w-[90rem] p-[0_1.25rem] clear-both m-[0_auto_2rem] xl:scroll-mt-28`
      )}
      id="courses"
    >
      <section
        /*  className={`xl:float-none clear-both float-[inherit] 
        xl:m-[2.5rem_auto_5rem] xl:min-h-[20rem] 
        md:pb-[3.25rem] md:m-[1.875rem_0] md:overflow-x-hidden md:min-h-[9.375rem] 
      float-[inherit] w-full m-[1.5625rem_0]
      overflow-x-scroll pb-[4.0625rem] relative z-0
      before:bg-[rgba(16,63,130,0.05)] before:absolute before:z-0 
      before:h-auto before:top-[17.54vw] before:bottom-0 before:left-0 
      before:pointer-events-none before:w-full
      `} */
        className={cn(
          `xl:float-none xl:m-[6rem_auto_5rem] xl:min-h-[20rem] `,
          `clear-both [float:inherit]`,
          `md:m-[1.875rem_0] md:pb-[3.25rem]  md:min-h-[9.375rem]`,
          `clear-both [float:inherit] m-[1.5625rem_0] pb-[4.0625rem] relative w-full z-[0]`,
          `before:bg-[rgba(16,63,130,0.05)] before:absolute before:z-0 
      before:h-auto before:top-[17.54vw] before:bottom-0 before:left-0 
      before:pointer-events-none before:w-full`
        )}
      /*  className={cn(
        `xl:float-none xl:m-[2.5rem_auto_5rem] xl:min-h-[20rem] `,
        `clear-both [float:inherit]`,
        `md:m-[1.875rem_0] md:pb-[3.25rem] md:overflow-x-hidden md:min-h-[9.375rem]`,
        `clear-both [float:inherit] m-[1.5625rem_0] overflow-x-scroll pb-[4.0625rem] relative w-full z-[0]`,
        ` before:bg-[rgba(16,63,130,0.05)] before:absolute before:z-0 
    before:h-auto before:top-[17.54vw] before:bottom-0 before:left-0 
    before:pointer-events-none before:w-full`
      )} */
      >
        <header
          className={`xl:w-[3.125rem] 
            w-[2.1875rem] border-b border-b-[#272727]
         block absolute top-0 left-0 [writing-mode:vertical-lr]`}
          style={{
            transform: "scale(-1)",
          }}
        >
          <h2
            className={`text-[0.75rem] xl:text-[1.5rem] xl:tracking-[0.125rem] 
           uppercase tracking-[0.09375rem] pb-[1.125rem] font-bold
          m-0 table-cell align-top whitespace-nowrap leading-[1]`}
          >
            Our Programmes
          </h2>
        </header>
        <div
          className={`xl:max-w-[75.625rem]
             md:flex md:justify-between md:max-w-[90rem] md:p-0 md:w-[87.5%] 
            items-baseline box-border m-auto 
            p-[0_2.8125rem] relative w-full`}
        >
          {OUR_PROGRAMS.map((item) => {
            return (
              <Link
                href={item.href}
                key={item.title.toLocaleLowerCase()}
                title={item.label}
                className={cn(`
                  xl:basis-[20.625rem] xl:mr-[1.875rem] 
                  xl:max-w-full
              md:basis-[13.25rem] md:mr-[1.0625rem] inline-block 
              basis-[14.5rem] m-[0_0_2rem] 
              [text-decoration:none]
              w-[14.5rem] z-[1] mr-[.5rem]
              `)}
              /* className={`xl:basis-[20.625rem] xl:mr-[1.875rem] 
              xl:max-w-full
          md:basis-[13.25rem] 
          md:mr-[1.0625rem] inline-block 
          basis-[14.5rem]
          [text-decoration:none]
          w-[14.5rem] z-[1]
          `} */
              >
                {/*   <picture width="330" height="408">
                  <img
                    src={item.image}
                    alt={item.title}
                    width="330"
                    height="408"
                    className={`md:mb-[1rem] md:max-h-fit h-fit mb-[0.9375rem] block max-w-full`}
                  />
                </picture> */}
                <Image
                  src={item.image}
                  alt={item.title}
                  width={330}
                  height={408}
                  className={`md:mb-[1rem] md:max-h-fit h-fit mb-[0.9375rem] block max-w-full`}
                />
                <span
                  /* className={`xl:both xl:text-[0.875rem] xl:leading-[1.125rem] 
                xl:m-[0_0_0.6875rem] md:mb-[0.5625rem] block 
                tracking-[0.125rem] hover:underline hover:decoration-primary-red`} */
                  className={`xl:both xl:text-sm
                  xl:m-[0_0_0.6875rem] md:mb-[0.5625rem] block 
                  hover:underline hover:decoration-primary-red`}
                >
                  <strong className="">{item.title}</strong>
                </span>
                {/*  <span
                className={`xl:text-[1.375rem] xl:leading-[2rem] md:leading-[1.625rem] futura-heavy cursor-pointer
                m-0 transition-[color_0.35s_ease-out] 
                `}
                style={{
                  backgroundImage:
                    "linear-gradient(to top,transparent 0.1875rem,#A31F34 0.1875rem,#A31F34 0.3125rem,transparent 0.3125rem)",
                }}
              >
                {item.description}
              </span> */}
              </Link>
            );
          })}
        </div>
      </section>
    </div>
  );
};

export default OurProgram;
